import { Injectable } from "@angular/core";
import { ProjectService, ProjectStructureService } from "@mydocma/project";
import { filter,startWith,switchMap,tap } from "rxjs/operators";

import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";
import { StructureNode, StructureTree } from "../structure/structure.model";
import { StructureApiService } from "./structure-api.service";
import { BpViewService } from "../../bp-view.service";

@Injectable({
providedIn: "root"
})
export class StructureService {

  private structuresTreeSubject =  new BehaviorSubject<StructureTree>(null);
  public structuresTree$ =  this.structuresTreeSubject.asObservable();

  private selectedStructureSubject = new BehaviorSubject<StructureNode>(null);
  public selectedStructure$ = this.selectedStructureSubject.asObservable();


  constructor(
    private readonly bpViewService: BpViewService,
    private readonly projectService: ProjectService,
    private readonly structureApiService: StructureApiService,
    private readonly projectStructureService: ProjectStructureService,
  ) {
    this.bpViewService.currentCustomer$
      .pipe(
        tap(currentCustomer => {
          this.structuresTreeSubject.next(null);
          this.projectStructureService.currentProjectStructureTree = null;
        }),
        switchMap(currentCustomer =>
          this.projectService.currentProject.pipe(
            // forces reevaluation on every customer change
            startWith(null),
            // When using bp in external applications, projectStructureTree may already be set
            // In these cases, structure tree should not be loaded again 
            filter((project) => {
              const currentProjectStructureTree = this.projectStructureService.currentProjectStructureTree;

              if (!currentProjectStructureTree) return true;
              return currentProjectStructureTree.projectId !== (project ? project.id : null);
            }),
            tap(() => this.structuresTreeSubject.next(null)),
            filter(Boolean),
            switchMap(project => this.structureApiService.get(project))
          )
        )
      )
      .subscribe(strTree => {
        this.projectStructureService.currentProjectStructureTree = strTree;
        this.structuresTreeSubject.next(strTree);
        this.selectedStructure = strTree;
      });

    this.projectStructureService.currentProjectStructureTree$$.subscribe(t => this.structuresTreeSubject.next(t));
    this.projectStructureService.currentProjectStructure$.subscribe(s => this.selectedStructureSubject.next(s as StructureNode));


  }

  public set selectedStructure(structure: StructureNode) {
    this.projectStructureService.currentProjectStructure = structure;
    this.selectedStructureSubject.next(structure);
  }
  public get selectedStructure(): StructureNode  {
    return this.selectedStructureSubject.value;
  }

  get structuresTree () : StructureTree {
    return this.structuresTreeSubject.value;
  }

  public async findPlanStructure( tree: StructureTree, plan: any) {
    if (tree !== null) {
        if (plan.structureId !== null) {
            if (tree.id === plan.structureId) {
              plan.structure = tree.name;
              plan.structurePath = tree.path;
            } else {
              const node = await this.getNodeById(tree, plan.structureId);

              if (node !== null && node.id === plan.structureId) {
                  plan.structure = node.name;
                  plan.structurePath = node.path;
              } else {
                  plan.structure = 'Don\'t have a structure for this plan'
                  plan.structurePath = 'Don\'t have a structure for this plan'
              }
            }
        } else {
            plan.structure = 'don\'t have a structure id'
            plan.structurePath = 'don\'t have a structure id'
        }
    }

    return plan;
  }



  getNodeById( tree: StructureTree, structureId: string ): StructureNode {
    if ( tree?.id === structureId ) {
      return tree;
    } else if ( tree?.children?.length > 0 ) {
      let result = null;
      for ( let i = 0; result == null && i < tree?.children.length; i++ ) {
        result =  this.getNodeById(tree?.children[i], structureId);
      }
      return result;
    }
    return null;
  }

}
